export const SET_BUSINESS_TYPE = "businessState/SET_BUSINESS_TYPE";
export const FORM_BUSINESS_TYPE_SUBMIT =
  "businessState/FORM_BUSINESS_TYPE_SUBMIT";
